const getDefaultOptions = options => {
  if (options && options.length) {
    let selected = [];
    options.forEach(option => {
      let selectedValues = [];
      if (option.values && option.values.length) {
        option.values.forEach(value => {
          if (value.selected) {
            const selectedValue = {
              id: value.id,
              quantity: 1,
              amountEffectType: value.amountEffectType,
              amount: value.amount,
              name: value.name,
              quantityAble: value.quantityAble,
              restaurantItemOptionValueId: value.id,
            };
            selectedValues.push(selectedValue);
          }
        });
      }
      if (selectedValues.length) {
        let selectedOption = {
          id: option.id,
          values: selectedValues,
        };
        selected.push(selectedOption);
      }
    });
    return selected;
  } else {
    return [];
  }
};

export default getDefaultOptions;
